import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { TarryProvider } from "./components/tarry/TarryContext";
import TarryWidget from "./components/tarry/TarryWidget";
import { useAnalytics } from "./hooks/useAnalytics";

function AnalyticsTracker() {
  useAnalytics();
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <TarryProvider>
          <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg focus:font-bold focus:text-sm">
            Skip to content
          </a>
          <AppRoutes />
          <TarryWidget />
          <AnalyticsTracker />
        </TarryProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
